import { HttpError } from './http-error.type';

export enum TransactionStatus {
  INITIAL = 'INITIAL',
  LOADING = 'LOADING',
  FAIL = 'FAIL',
  SUCCESS = 'SUCCESS',
  POLLING = 'POLLING',
}

export interface PollingData {
  status: TransactionStatus;
  error: HttpError | null;
}
